import { useState } from 'react';
import { useDarkMode } from '../../hooks/useDarkMode';
import AdminHeader from '../../components/AdminHeader';

export default function GerarLink() {
  const isDark = useDarkMode();
  const [audioUrl, setAudioUrl] = useState('');
  const [nome, setNome] = useState('');
  const [titulo, setTitulo] = useState('');
  const [imagem, setImagem] = useState('');
  const [letra, setLetra] = useState('');
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  const canGenerate = audioUrl.trim() && nome.trim();

  const generate = async () => {
    if (!canGenerate) return;
    setLoading(true);
    setError('');
    setLink('');
    try {
      const res = await fetch('/api/salvar-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          audio_url: audioUrl.trim(),
          nome: nome.trim(),
          titulo: titulo.trim() || undefined,
          imagem: imagem.trim() || undefined,
          letra: letra.trim() || undefined,
        }),
      });
      const data = await res.json();
      if (data.slug) {
        setLink(`https://inspiramusicas.com.br/ouvir/${data.slug}`);
      } else {
        setError('Erro ao salvar. Verifique se a tabela foi criada no Supabase.');
      }
    } catch {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const copy = () => {
    if (!link) return;
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: 12,
    border: '1.5px solid var(--border-soft)',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 15,
    color: 'var(--text-body)',
    background: 'var(--cream)',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const labelStyle: React.CSSProperties = {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12,
    fontWeight: 700,
    color: 'var(--amber-deep)',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    display: 'block',
    marginBottom: 6,
  };

  return (
    <div className="admin-shell" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AdminHeader title="Gerar link" />
      <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 16px 60px' }}>
      <div className="admin-glass" style={{ background: 'var(--surface-white)', borderRadius: 24, padding: 40, width: '100%', maxWidth: 520 }}>
        <img src={isDark ? '/logo-dark.png' : '/logo-light.png'} alt="Inspira Músicas" style={{ height: 52, marginBottom: 28 }} />

        <h1 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 24, fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--heading-ink)', margin: '0 0 6px' }}>
          Gerar link de entrega
        </h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: 'var(--text-muted)', margin: '0 0 28px' }}>
          Preencha os campos e clique em "Gerar link". Apenas URL do áudio e nome são obrigatórios.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <div>
            <label style={labelStyle}>URL do áudio (Supabase) *</label>
            <input
              type="text"
              placeholder="https://...supabase.co/storage/v1/object/public/musicas/..."
              value={audioUrl}
              onChange={e => { setAudioUrl(e.target.value); setLink(''); }}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Nome da pessoa homenageada *</label>
            <input
              type="text"
              placeholder="Ex: Márcia"
              value={nome}
              onChange={e => { setNome(e.target.value); setLink(''); }}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Título da música <span style={{ fontWeight: 400, textTransform: 'none', color: 'var(--text-soft)' }}>(opcional)</span></label>
            <input
              type="text"
              placeholder="Ex: Canção para Márcia"
              value={titulo}
              onChange={e => { setTitulo(e.target.value); setLink(''); }}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>URL da imagem / capa <span style={{ fontWeight: 400, textTransform: 'none', color: 'var(--text-soft)' }}>(opcional)</span></label>
            <input
              type="text"
              placeholder="https://... (Supabase, Unsplash, etc.)"
              value={imagem}
              onChange={e => { setImagem(e.target.value); setLink(''); }}
              style={inputStyle}
            />
          </div>

          <div>
            <label style={labelStyle}>Letra da música <span style={{ fontWeight: 400, textTransform: 'none', color: 'var(--text-soft)' }}>(opcional)</span></label>
            <textarea
              placeholder="Cole aqui a letra completa da música..."
              value={letra}
              onChange={e => { setLetra(e.target.value); setLink(''); }}
              rows={8}
              style={{ ...inputStyle, resize: 'vertical', lineHeight: 1.7 }}
            />
          </div>
        </div>

        <button
          onClick={generate}
          disabled={!canGenerate || loading}
          style={{
            width: '100%', marginTop: 24, padding: '14px 0', borderRadius: 999, border: 'none',
            background: canGenerate && !loading ? 'var(--gold)' : 'var(--badge-bg)',
            color: canGenerate && !loading ? 'var(--gold-ink)' : 'var(--text-soft)',
            fontFamily: "'DM Sans', sans-serif", fontSize: 16, fontWeight: 700,
            cursor: canGenerate && !loading ? 'pointer' : 'default', transition: 'background 0.2s',
            boxShadow: canGenerate && !loading ? '0 6px 20px rgba(255,108,108,0.34)' : 'none',
          }}
        >
          {loading ? 'Gerando...' : '🎵 Gerar link'}
        </button>

        {error && (
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#a93232', margin: '12px 0 0', textAlign: 'center' }}>
            {error}
          </p>
        )}

        {link && (
          <div style={{ marginTop: 24 }}>
            <label style={labelStyle}>Link gerado</label>
            <div style={{
              background: 'var(--gold-pale)', border: '1.5px solid var(--gold-border)',
              borderRadius: 12, padding: '12px 16px',
              fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: 'var(--amber-deep)',
              wordBreak: 'break-all', marginBottom: 12, fontWeight: 600,
            }}>
              {link}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={copy}
                style={{
                  flex: 1, padding: '12px 0', borderRadius: 999, border: 'none',
                  background: copied ? 'var(--color-success-border)' : 'var(--gold)', color: copied ? '#fff' : 'var(--gold-ink)',
                  fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 600,
                  cursor: 'pointer', transition: 'background 0.2s',
                }}
              >
                {copied ? '✓ Copiado!' : 'Copiar link'}
              </button>
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                style={{
                  flex: 1, padding: '12px 0', borderRadius: 999,
                  border: '1.5px solid var(--gold)', color: 'var(--gold)',
                  fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 600,
                  textDecoration: 'none', textAlign: 'center',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                }}
              >
                Testar
              </a>
            </div>
          </div>
        )}
      </div>
      </div>
    </div>
  );
}
